module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('bo-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phoneMode != 'hide'),
      expression: "phoneMode!='hide'"
    }],
    ref: "phone",
    attrs: {
      "holder": "输入手机号",
      "size": "lg",
      "label": "手机号",
      "theme": "blank",
      "format": "phone",
      "required": true,
      "enable": _vm.phoneMode != 'disable'
    },
    model: {
      value: (_vm.phoneSelf),
      callback: function($$v) {
        _vm.phoneSelf = $$v
      },
      expression: "phoneSelf"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-item form-item-blank form-code"
  }, [_c('label', {
    staticClass: "label-lg",
    attrs: {
      "for": ""
    }
  }, [_vm._v("验证码")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "input input-lg form-control rbb",
    attrs: {
      "type": "text",
      "name": "name",
      "value": "",
      "placeholder": "请输入内容"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-code-btn"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lock),
      expression: "lock"
    }],
    staticClass: "btn btn-code input-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.clock) + "秒后重发")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.lock),
      expression: "!lock"
    }],
    staticClass: "btn btn-code input-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendCode
    }
  }, [_vm._v("获取验证码")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-19a13a35!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/phone-code/phone-code.vue
// module id = 229
// module chunks = 5